import React, { Component, Fragment } from "react";
import "./Profile.css";

import { connect } from "react-redux";
import * as actions from "../../store/actions";
import { showErrorToast } from "../../utils/errorHandler";

import { Grid } from "@mui/material";
import Add from "@mui/icons-material/Add";

import Input from "../../containers/UI/Input/Input";
import Spinner from "../../containers/UI/Spinner/Spinner";

class Profile extends Component {
  state = {
    logoLoading: false,
    editable: false,
  };

  componentDidMount = () => {
    if (this.props.merchantId) {
      this.props.getDetails(this.props.merchantId);
    }
  };

  onInputHandler = (event) => {
    this.props.updateProfileObj(event.target.name, event.target.value);
  };

  onSubmitClick = () => {
    this.props.putDetails(this.props.merchantId, this.props.profile);
    this.setState({ editable: false });
  };

  onChangeHandler = (event) => {
    const file = event.target.files[0];
    if (!file || !this.props.merchantId) return;

    // Pre-flight validation — must match multer limit on the backend (5 MB)
    const MAX_LOGO_SIZE = 5 * 1024 * 1024; // 5 MB
    const ALLOWED_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];

    if (file.size > MAX_LOGO_SIZE) {
      showErrorToast({ message: 'Logo file is too large. Maximum size is 5 MB.' });
      // Reset the input so the same file can be re-selected after choosing a smaller one
      event.target.value = '';
      return;
    }

    if (!ALLOWED_TYPES.includes(file.type)) {
      showErrorToast({ message: 'Unsupported file type. Please use JPEG, PNG, or WebP.' });
      event.target.value = '';
      return;
    }

    this.uploadLogo(file);
  };

  uploadLogo = async (file) => {
    this.setState({ logoLoading: true });
    
    try {
      await this.props.uploadLogo(this.props.merchantId, file);
      this.setState({ logoLoading: false });
    } catch (error) {
      this.setState({ logoLoading: false });
    }
  };

  editToggle = () => {
    this.setState({ editable: true });
  };

  editToggleFalse = () => {
    this.setState({ editable: false });
  };

  render() {
    let { loading, profile, user } = this.props;
    let { logoLoading, editable } = this.state;

    // Show spinner while loading or if profile is not yet loaded
    if (loading || !profile) {
      return (
        <div className="profileContent">
          <div className="profileContentBox">
            <Spinner />
          </div>
        </div>
      );
    }

    return (
      <div className="profileContent">
        <div className="profileContentBox">
          <div className="profileBoxTitle">
            <span>Merchant Profile</span>
          </div>

          <div>
            {/* Merchant Logo */}
            <div className="profileBoxAvatar">
              <div className="profileBoxProfile">
                <span>Merchant Logo:</span>

                <input
                  accept="image/*"
                  className={"inputAvatarBox"}
                  id="MerchantLogo"
                  type="file"
                  onChange={(e) => this.onChangeHandler(e)}
                  disabled={!editable}
                />

                <label htmlFor="MerchantLogo" className={"imgBox"}>
                  {logoLoading ? (
                    <Spinner />
                  ) : profile.logoUrl ? (
                    <img
                      src={profile.logoUrl}
                      alt="Merchant Logo"
                    />
                  ) : (
                    <Add color="secondary" fontSize="large" />
                  )}
                </label>
              </div>
            </div>

            <div className="pforileBoxInputs">
              {/* Merchant Business Information */}
              <div className="profileBoxDivider"></div>
              <div className="profileBoxText">
                <span>Business Information</span>
              </div>
              <Grid container direction="row" spacing={1}>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Input
                    type="text"
                    label="Company Name"
                    value={profile.name || ''}
                    name="name"
                    onChange={this.onInputHandler}
                    editable={false}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Input
                    type="text"
                    label="CR Number"
                    value={profile.crNumber || ''}
                    name="crNumber"
                    onChange={this.onInputHandler}
                    editable={false}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <div className="signupInputClass">
                    <div className="profileDetailsInputLabel">
                      Minimum Order Amount
                    </div>
                    <div className="signupInputPassInput">
                      {editable ? (
                        <input
                          className="signupInputPass"
                          type="number"
                          value={profile.minOrderAmount || 0}
                          name="minOrderAmount"
                          onChange={this.onInputHandler}
                        />
                      ) : (
                        <input
                          className="signupInputPass nonEditable"
                          type="number"
                          value={profile.minOrderAmount || 0}
                          name="minOrderAmount"
                          disabled
                        />
                      )}
                      <div className="profileInputIcon">QAR</div>
                    </div>
                  </div>
                </Grid>
              </Grid>

              {/* Address Information */}
              <div className="profileBoxDivider"></div>
              <div className="profileBoxText">
                <span>Address</span>
              </div>
              <Grid container direction="row" spacing={1}>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Input
                    type="text"
                    label="Zone Number"
                    value={profile.zoneNumber || ''}
                    name="zoneNumber"
                    onChange={this.onInputHandler}
                    editable={editable}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Input
                    type="text"
                    label="Street Number"
                    value={profile.streetNumber || ''}
                    name="streetNumber"
                    onChange={this.onInputHandler}
                    editable={editable}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Input
                    type="text"
                    label="Building Number"
                    value={profile.buildingNumber || ''}
                    name="buildingNumber"
                    onChange={this.onInputHandler}
                    editable={editable}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Input
                    type="text"
                    label="Unit Number"
                    value={profile.unitNumber || ''}
                    name="unitNumber"
                    onChange={this.onInputHandler}
                    editable={editable}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Input
                    type="text"
                    label="Address Notes"
                    value={profile.addressNotes || ''}
                    name="addressNotes"
                    onChange={this.onInputHandler}
                    editable={editable}
                  />
                </Grid>
              </Grid>

              {/* User Account Information */}
              {user && (
                <>
                  <div className="profileBoxDivider"></div>
                  <div className="profileBoxText">
                    <span>Account Information</span>
                  </div>
                  <Grid container direction="row" spacing={1}>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Input
                        type="text"
                        label="First Name"
                        value={user.firstName || ''}
                        name="firstName"
                        editable={false}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Input
                        type="text"
                        label="Last Name"
                        value={user.lastName || ''}
                        name="lastName"
                        editable={false}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Input
                        type="email"
                        label="Email"
                        value={user.email || ''}
                        name="email"
                        editable={false}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Input
                        type="text"
                        label="Phone"
                        value={user.phone || ''}
                        name="phone"
                        editable={false}
                      />
                    </Grid>
                    {user.secondaryPhone && (
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Input
                          type="text"
                          label="Secondary Phone"
                          value={user.secondaryPhone || ''}
                          name="secondaryPhone"
                          editable={false}
                        />
                      </Grid>
                    )}
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Input
                        type="text"
                        label="Role"
                        value={user.role || ''}
                        name="role"
                        editable={false}
                      />
                    </Grid>
                  </Grid>
                </>
              )}

              {/* Action Buttons */}
              <div className="profileBoxButtonBox">
                {!editable ? (
                  <div
                    className="profileBoxLogout"
                    onClick={this.props.logout}
                  >
                    <span>Log out</span>
                  </div>
                ) : null}
                {!editable ? (
                  <div className="profileBoxButton" onClick={this.editToggle}>
                    <span>Edit</span>
                  </div>
                ) : (
                  <Fragment>
                    <div
                      className="profileBoxLogout"
                      onClick={this.editToggleFalse}
                    >
                      <span>Cancel</span>
                    </div>
                    <div
                      className="profileBoxButton"
                      onClick={this.onSubmitClick}
                    >
                      <span>Save changes</span>
                    </div>
                  </Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    profile: state.profile.profileDetails,
    loading: state.profile.loading,
    merchantId: state.auth.user?.merchantId,
    user: state.auth.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDetails: (merchantId) =>
      dispatch(actions.getMerchantProfile(merchantId)),
    updateProfileObj: (name, value) =>
      dispatch(actions.updateProfileObj(name, value)),
    putDetails: (merchantId, profileData) =>
      dispatch(actions.updateMerchantProfile(merchantId, profileData)),
    uploadLogo: (merchantId, file) =>
      dispatch(actions.uploadMerchantLogo(merchantId, file)),
    logout: () => dispatch(actions.logout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
